"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_StructureMap_Structure = exports.StructureMap_StructureModeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_canonical_1 = require("../Scalar/RTTI_canonical");
var RTTI_Element_1 = require("./RTTI_Element");
var StructureMap_StructureModeKind;
(function (StructureMap_StructureModeKind) {
    StructureMap_StructureModeKind["_source"] = "source";
    StructureMap_StructureModeKind["_queried"] = "queried";
    StructureMap_StructureModeKind["_target"] = "target";
    StructureMap_StructureModeKind["_produced"] = "produced";
})(StructureMap_StructureModeKind = exports.StructureMap_StructureModeKind || (exports.StructureMap_StructureModeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_StructureMap_Structure = t.recursion('IStructureMap_Structure', function () {
    return t.intersection([
        t.type({
            url: RTTI_canonical_1.RTTI_canonical
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            mode: (0, EnumType_1.createEnumType)(StructureMap_StructureModeKind, 'StructureMap_StructureModeKind'),
            _mode: RTTI_Element_1.RTTI_Element,
            alias: t.string,
            _alias: RTTI_Element_1.RTTI_Element,
            documentation: t.string,
            _documentation: RTTI_Element_1.RTTI_Element
        })
    ]);
});
//# sourceMappingURL=RTTI_StructureMap_Structure.js.map